module.exports = __webpack_public_path__ + "img/front_skirt_length.96360ff0.png";